<div
  [hidden]="display.useCompanyAddress"
  class="list-group-item address-fields"
>
  <div class="form-group">
    <label class="control-label">Description:</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="display.addressDescription"
    />
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label class="control-label">Street:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="display.street"
          name="street"
        />
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label class="control-label">Unit:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="display.unit"
          name="unit"
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label class="control-label">City:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="display.city"
          name="city"
        />
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label id="display-address-country-label" class="control-label"
          >Country:</label
        >
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="tw-w-full"
        >
          <mat-select
            id="displayAddressCountrySelect"
            [(ngModel)]="display.country"
            name="country"
            (selectionChange)="detectChanges()"
            aria-labelledby="display-address-country-label"
            placeholder="Select Country"
          >
            @for (c of countries; track c) {
              <mat-option [value]="c.code" [disabled]="c.code === null">
                {{ c.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label id="display-address-region-label" class="control-label"
          >State/Province/Region:</label
        >
        @if (display.country !== 'US' && display.country !== 'CA') {
          <input
            type="text"
            class="form-control"
            [(ngModel)]="display.province"
            name="province"
          />
        } @else if (display.country === 'CA') {
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            class="tw-w-full"
          >
            <mat-select
              [(ngModel)]="display.province"
              name="province"
              aria-labelledby="display-address-region-label"
              placeholder="Select Province"
            >
              @for (r of regionsCA; track r) {
                <mat-option [value]="r[1]">{{ r[0] }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else if (display.country === 'US') {
          <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
            class="tw-w-full"
          >
            <mat-select
              [(ngModel)]="display.province"
              name="province"
              aria-labelledby="display-address-region-label"
              placeholder="Select State"
            >
              @for (r of regionsUS; track r) {
                <mat-option [value]="r[1]">{{ r[0] }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label class="control-label">Zip / Postal Code:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="display.postalCode"
          name="postalCode"
        />
      </div>
    </div>
  </div>
</div>
<!--display address-->
